import { render, staticRenderFns } from "./crowd-invaded.vue?vue&type=template&id=4c5a3142&scoped=true&"
import script from "./crowd-invaded.vue?vue&type=script&lang=ts&"
export * from "./crowd-invaded.vue?vue&type=script&lang=ts&"
import style0 from "./crowd-invaded.vue?vue&type=style&index=0&id=4c5a3142&prod&scoped=true&lang=scss&"
import style1 from "./crowd-invaded.vue?vue&type=style&index=1&id=4c5a3142&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5a3142",
  null
  
)

export default component.exports